import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import masterApi from '../../api/masters'

export interface RootState {
    version: string;
}

export class Templates {
    data: string | undefined;
    name: string | undefined;

}
const state = Array<Templates>();
const getters: GetterTree<Array<Templates>, RootState> = {
    Templates(state: Array<Templates>) {
        return state
    }
};
export const mutations: MutationTree<Array<Templates>> = {
    LOAD_TEMPLATE(state: Array<Templates>, Templatess: Array<Templates>) {
        Templatess.forEach(element => {
            state.push(element)
        });
    },
    CLEAR_TEMPLATE(state: Array<Templates>) {
        state.length = 0
    }
};
const actions: ActionTree<Array<Templates>, RootState> = {
    async getTemplate({ state, commit }: { commit: Commit, state: Array<Templates> }, param: string): Promise<string | undefined> {
        commit('CLEAR_TEMPLATE')
        let template = state.find(f => f.name == param)
        if (template) return template.data;
        try {
            const response = await masterApi.getTemplate(param)
            if (response && response.data && response.data.resultType === 200) {
                const Templatess: Templates[] | PromiseLike<Templates[]> = [];
                template = { name: response.data.payload.name, data: JSON.parse(response.data.payload.jsonData) }
                Templatess.push(template)
                commit('LOAD_TEMPLATE', Templatess)
                return template.data;
            }
            else {
                commit('CLEAR_TEMPLATE')

            }
        }
        catch (error) {
            commit('CLEAR_TEMPLATE')

        }
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}